import React from 'react';
import MeasurementsForm from './components/MeasurementsForm';

const App = () => {
	return (
		<div className='App'>
			<MeasurementsForm />
		</div>
	);
};

export default App;
